import { COUNTRY_IDS } from "constants/global";
import { get } from "./AXIOS";
import { GET_POLICY_TYPES, GET_SUB_NATIONALS } from "./CONSTANTS";

export const getSubNationals = (countryId) => {
  return get(GET_SUB_NATIONALS(countryId));
};

export const getPolicyTypes = (countryId) => {
  return get(GET_POLICY_TYPES(countryId));
};

export const supportsSubNational = (countryId) => {
  return [
    COUNTRY_IDS.ETHIOPIA,
    COUNTRY_IDS.NIGERIA, 
    COUNTRY_IDS.KENYA
  ].includes(parseInt(countryId));
};

// Helper to check if a country requires policy type selection
export const requiresPolicyType = (countryId) => {
  return [
    COUNTRY_IDS.ETHIOPIA,
    COUNTRY_IDS.MALAWI
  ].includes(parseInt(countryId));
};

// Get the label for sub-national selection based on country
export const getSubNationalLabel = (countryId) => {
  switch (parseInt(countryId)) {
    case COUNTRY_IDS.KENYA:
      return 'County';
    case COUNTRY_IDS.ETHIOPIA:
      return 'Region';
    case COUNTRY_IDS.NIGERIA:
      return 'State';
    default:
      return '';
  }
};

// Format API response to React-Select options format
export const formatToSelectOptions = (data) => {
  if (!data || !Array.isArray(data)) return [];
  
  return data.map(item => ({
    value: item.id,
    label: item.name
  }));
};
